import Poll from "play/screens/poll"
import { ClientScreen } from "../play-model"
import "./screen-page.less"
import Presentation from "./presentation"
import Quiz from "./quiz"
import Map from "./map"
import Connect from "./connect"
import DragDrop from "./drag-drop"
import Draw from "./draw"
import Keyboard from "./keyboard"
import Layout from "../layouts/layout"
import OpenText from "play/screens/open-text"
import { ScreenType } from "models/tables"

function NotImplemented(props: { type: string }) {
  const { type } = props

  return <p>Screen type {type} not implemented</p>
}

type Props = {
  screen: ClientScreen
}

export function ScreenPage(props: Props) {
  const { screen } = props

  let currentScreen = <NotImplemented type={screen.screenType + ""} />

  switch (screen.screenType) {
    case ScreenType.Connect:
      currentScreen = <Connect key={screen.id} />
      break
    case ScreenType.DragDrop:
      currentScreen = <DragDrop key={screen.id} />
      break
    case ScreenType.Drawing:
      currentScreen = <Draw key={screen.id} />
      break
    case ScreenType.Keyboard:
      currentScreen = <Keyboard key={screen.id} />
      break
    case ScreenType.Map:
      currentScreen = <Map key={screen.id} />
      break
    case ScreenType.Presentation:
      currentScreen = <Presentation key={screen.id} />
      break
    case ScreenType.Quiz:
      currentScreen = <Quiz key={screen.id} />
      break
    case ScreenType.Poll:
      currentScreen = <Poll key={screen.id} />
      break
    case ScreenType.OpenText:
      currentScreen = <OpenText key={screen.id} />
      break
  }

  return <Layout>{currentScreen}</Layout>
}

export default ScreenPage
